import { AuthGuard } from '@enerbim/commons-lib';
const ɵ0 = () => import("./features/home/home.module.ngfactory").then(m => m.HomeModuleNgFactory), ɵ1 = () => import("./features/home/home.module.ngfactory").then(m => m.HomeModuleNgFactory), ɵ2 = {
    openLoginDialog: true
}, ɵ3 = () => import("./features/error/error.module.ngfactory").then(m => m.ErrorModuleNgFactory), ɵ4 = () => import("./features/error/error.module.ngfactory").then(m => m.ErrorModuleNgFactory), ɵ5 = {
    error403: true
}, ɵ6 = () => import("./lib-routing.modules.ngfactory").then(m => m.PasswordResetModuleNgFactory), ɵ7 = () => import("./lib-routing.modules.ngfactory").then(m => m.InscriptionFinishModuleNgFactory), ɵ8 = () => import("./lib-routing.modules.ngfactory").then(m => m.ProfileModuleNgFactory), ɵ9 = () => import("./lib-routing.modules.ngfactory").then(m => m.MarkdownModuleNgFactory), ɵ10 = {
    pageTitle: 'Journal des modifications',
    markdownFile: '/assets/changelog/changelog.md'
}, ɵ11 = () => import("./lib-routing.modules.ngfactory").then(m => m.MarkdownModuleNgFactory), ɵ12 = {
    pageTitle: 'Informations légales',
    markdownFile: '/assets/legal/mentions-legales.md'
}, ɵ13 = () => import("./features/admin/admin.module.ngfactory").then(m => m.AdminModuleNgFactory), ɵ14 = () => import("./features/referentiel/referentiel.module.ngfactory").then(m => m.ReferentielModuleNgFactory), ɵ15 = {
    modulePreload: true,
    modulePreloadDelaySeconds: 2,
    moduleName: 'bim',
}, ɵ16 = () => import("./features/bim/bim.module.ngfactory").then(m => m.BimModuleNgFactory);
const APP_ROUTES = [
    {
        path: '',
        loadChildren: ɵ0
    },
    {
        // Il faut que l'URL "login" redirige vers la home en ouvrant la popup de login (redirection vers /login faite par intercepteur dans lib commune)
        path: 'login',
        loadChildren: ɵ1,
        data: ɵ2
    },
    {
        path: 'error',
        loadChildren: ɵ3
    },
    {
        path: 'access-denied',
        loadChildren: ɵ4,
        data: ɵ5
    },
    {
        path: 'password-reset',
        loadChildren: ɵ6
    },
    {
        path: 'inscription/finish',
        loadChildren: ɵ7
    },
    {
        path: 'profile',
        canActivate: [AuthGuard],
        loadChildren: ɵ8
    },
    {
        path: 'changelog',
        canActivate: [AuthGuard],
        loadChildren: ɵ9,
        data: ɵ10
    },
    {
        path: 'legal',
        canActivate: [AuthGuard],
        loadChildren: ɵ11,
        data: ɵ12
    },
    {
        path: 'admin',
        canActivate: [AuthGuard],
        loadChildren: ɵ13
    },
    {
        path: 'referentiel',
        canActivate: [AuthGuard],
        loadChildren: ɵ14
    },
    {
        path: 'bim/:element-type/:id',
        canActivate: [AuthGuard],
        data: ɵ15,
        loadChildren: ɵ16
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16 };
